import { useEffect, useRef } from "react";
import { useLocalStorage } from "react-use";
import {
  CurrencyToggleMode,
  useCurrencyDisplay,
} from "@providers/CurrencyDisplayProvider";

const DEFAULT_VIEW: CurrencyToggleMode = "original";

export const useCurrencyToggleStorage = (storageKey: string) => {
  const { selectedCurrencyView, setSelectedCurrencyView } =
    useCurrencyDisplay();
  const [stored, setStored] = useLocalStorage<CurrencyToggleMode>(storageKey);
  const lastSyncedKey = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (lastSyncedKey.current === storageKey) return;
    lastSyncedKey.current = storageKey;
    const next = stored ?? DEFAULT_VIEW;
    if (next !== selectedCurrencyView) {
      setSelectedCurrencyView(next);
    }
  }, [storageKey, stored, selectedCurrencyView, setSelectedCurrencyView]);

  const onChange = (mode: CurrencyToggleMode) => {
    setSelectedCurrencyView(mode);
    setStored(mode);
  };

  return { value: selectedCurrencyView, onChange };
};
